import { render, staticRenderFns } from "./uploadImageManageList.vue?vue&type=template&id=704af9e9&scoped=true"
import script from "./uploadImageManageList.vue?vue&type=script&lang=js"
export * from "./uploadImageManageList.vue?vue&type=script&lang=js"
import style0 from "./uploadImageManageList.vue?vue&type=style&index=0&id=704af9e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704af9e9",
  null
  
)

export default component.exports